/**
 * Creates a map for O(1) lookups of selected items by key
 * @param selectedItems - The array of selected items
 * @param keyName - The key property to use for mapping
 * @returns A Map with item keys as keys and items as values
 */
export function createSelectedItemsMap<T>(
  selectedItems: T[] | undefined,
  keyName: keyof T
): Map<string, T> {
  const map = new Map<string, T>();

  if (selectedItems?.length) {
    selectedItems.forEach((item) => {
      map.set(String(item[keyName]), item);
    });
  }

  return map;
}
